"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateProperty = class CreateProperty extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resource;
    async $$load_resource() {
        return this.$fn.schemaDefaults('CreateProperty', { owner: null });
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    container;
    async $$load_container() {
        return {
            self: this.$fn.urlFor('create_property'),
            object: 'list',
            data: []
        };
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    propertyUnitTypes;
    async $$load_propertyUnitTypes() {
        return this.$fn.fetch('list_property_types').then(p => _.orderBy(p, ['name']));
    }
    units;
    resourceTitle;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['resource', 'editor', 'container', 'formName', 'formId', 'propertyUnitTypes', 'units', 'resourceTitle', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resource: null,
                editor: null,
                container: null,
                formName: "meter",
                formId: null,
                propertyUnitTypes: null,
                units: ["ha",
                    "m2",
                ],
                resourceTitle: this.$fn.pgettext("Property", "Property"),
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Property", "New property"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5390_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_5396_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_navigate_5398_getActionArgs($event) {
        return {
            location: {
                name: "app.property",
                params: {
                    id: $event.data.response.data.id,
                },
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_5400_getActionArgs($event) {
        return {
            grid: "properties",
        };
    }
    async act_1040167445267876_rest_5394_getActionArgs($event) {
        return {
            method: "save",
            container: this.container,
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5390 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5390_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5389 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5390,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5389],
        });
        const act_2248226175642056_closeComponent_5392 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_5391 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5392,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5391],
        });
        const act_1040167445267876_closeComponent_5396 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_5396_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_5395 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_5396,
            event: "saved",
            displayName: "closeComponent",
        });
        const act_1040167445267876_navigate_5398 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_5398_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_5397 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_5398,
            event: "saved",
            displayName: "navigate",
        });
        const act_1040167445267876_reloadSlickgrid_5400 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_5400_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_5399 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_5400,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_rest_5394 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_5394_getActionArgs,
            displayName: "create",
            events: [evh_1040167445267876_saved_5395, evh_1040167445267876_saved_5397, evh_1040167445267876_saved_5399],
        });
        const evh_1040167445267876_submit_5393 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_5394,
            event: "submit",
            displayName: "create",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5393],
        });
        const act_1419464017721962_closeComponent_5402 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_5401 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_5402,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_5401],
        });
        return {
            act_7315092382398562_closeModal_5390,
            evh_7315092382398562_close_5389,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5392,
            evh_2248226175642056_close_5391,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_5396,
            evh_1040167445267876_saved_5395,
            act_1040167445267876_navigate_5398,
            evh_1040167445267876_saved_5397,
            act_1040167445267876_reloadSlickgrid_5400,
            evh_1040167445267876_saved_5399,
            act_1040167445267876_rest_5394,
            evh_1040167445267876_submit_5393,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_5402,
            evh_1419464017721962_clickPreventStop_5401,
            evh_1419464017721962_clickPreventStop,
            create: act_1040167445267876_rest_5394,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreateProperty.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateProperty.prototype, "onSize", null);
CreateProperty = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateProperty);
exports.default = CreateProperty;
vue_property_decorator_1.Vue.component("CreateProperty", CreateProperty);
